import type { IconSvgObject } from './types';

const ViewAgendaIcon: IconSvgObject = [
  ["path", { d: "M4 5L4 9C4 9.55228 4.4477 10 5 10L19 10C19.5523 10 20 9.55228 20 9V5C20 4.44772 19.5523 4 19 4L5 4C4.4477 4 4 4.44772 4 5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 15L4 19C4 19.5523 4.4477 20 5 20L19 20C19.5523 20 20 19.5523 20 19V15C20 14.4477 19.5523 14 19 14L5 14C4.4477 14 4 14.4477 4 15Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ViewAgendaIcon;
